import { CommandFlag } from './types';

/** Shared navy current, mid-blue predicted and neutral break-even palette. */
export const tcc = {
  booked: '#172b46',
  predicted: '#427db6',
  predictedBand: '#3d75ab',
  neutralBand: '#5b6770',
  saleText: 'var(--tcc-sale-text, #17685f)',
  breakeven: 'var(--tcc-breakeven, #52514e)',
  track: 'var(--tcc-track, #eceae4)',
  predictedText: 'var(--tcc-predicted-text, #326799)',
  bookedText: 'var(--tcc-booked-text, #172b46)',
  grid: { light: '#e1e0d9', dark: '#2c2c2a' },
  axis: '#898781',
  red: '#d03b3b',
  amber: '#fab219',
  green: '#637f79',
  empty: '#63758a',
  emptyText: 'var(--tcc-empty-text, #42556c)',
  // Text steps of the status colours: darker on the light theme, the status colours themselves on dark.
  // Set per theme by `tccVariables` on the page root.
  redText: 'var(--tcc-red-text, #b42318)',
  amberText: 'var(--tcc-amber-text, #9a6100)',
  greenText: 'var(--tcc-green-text, #415e58)',
};

/** CSS variables behind the theme-dependent colours above; spread into the page root's sx. */
export const tccVariables = (mode: 'light' | 'dark') =>
  mode === 'dark'
    ? {
        '--tcc-breakeven': '#c3c2b7',
        '--tcc-track': '#383835',
        '--tcc-empty-month': '#323b46',
        '--tcc-predicted-text': '#86b6ef',
        '--tcc-booked-text': '#6da7ec',
        '--tcc-red-text': '#f08a8a',
        '--tcc-amber-text': '#fab219',
        '--tcc-green-text': '#a3bdb5',
        '--tcc-sale-text': '#78cfc0',
        '--tcc-empty-text': '#a9bbd0',
      }
    : {};

export const toneText = { red: tcc.redText, amber: tcc.amberText, green: tcc.greenText } as const;

export const actionColour = (flag: CommandFlag) =>
  flag === 'red'
    ? tcc.red
    : flag === 'amber'
      ? tcc.amber
      : flag === 'green'
        ? tcc.green
        : flag === 'empty'
          ? '#655779'
          : '#7b8490';
export const actionText = (flag: CommandFlag) =>
  flag === 'red' ? tcc.redText : flag === 'amber' ? tcc.amberText : flag === 'green' ? tcc.greenText : 'text.secondary';
